<template>
  <div class="orders-panel-wrapper">
    <Header> </Header>

    <PageContainer style="padding-bottom: 300px">
      <IQOS :title="$t('orders_panel_download.title')" required>
        <div class="qrw-heading-xs mt-16">
          <span class="v1-grey-7-color">{{
            $t("orders_panel_download.id_hint")
          }}</span>
          <span class="green-6-color"> {{ cafe.qId }}</span>
        </div>
        <BaseDivider color="v1-grey-4" class="mt-24 mb-24" />
        <div class="qrw-heading-xs">
          <span class="v1-grey-10-color bold"> Web App </span>
          <span class="v1-grey-7-color">
            | {{ $t("orders_panel_download.web_hint") }}
          </span>
        </div>
        <div class="panel-btns mt-16">
          <BaseButton
            size="md"
            class="mr-8"
            variant="secondary"
            icon="copy"
            @click="copyLink"
          >
            {{ $t("orders_panel_download.btn_copy") }}
          </BaseButton>
          <div class="iqos-tooltip-helper-box mr-8">
            <BaseButton
              @click="show_queue_qrcode = !show_queue_qrcode"
              size="md"
              variant="secondary"
              icon="qr-code"
            >
              {{ $t("orders_panel_download.btn_qr") }}
            </BaseButton>

            <IQOSTooltip
              @close="show_queue_qrcode = !show_queue_qrcode"
              :title="$t('navbar.orders_panel')"
              :qrLink="webQueueLink"
              v-if="show_queue_qrcode"
            >
            </IQOSTooltip>
          </div>

          <a :href="webQueueLink" target="_blank"
            ><BaseButton size="md" variant="secondary" icon="telegram-filled">
              {{ $t("orders_panel_download.btn_open") }}
            </BaseButton></a
          >
        </div>
        <!-- <BaseDivider color="v1-grey-4" class="mt-24 mb-24" />
        <div class="qrw-heading-xs">
          <span class="v1-grey-10-color bold"> Desktop App </span>
        </div>
        <div class="panel-btns mt-16">
          <BaseButton size="md" class="mr-8" variant="secondary" icon="windows">
            {{ $t("orders_panel_download.btn_download") }}
          </BaseButton>
          <BaseButton size="md" variant="secondary" icon="apple">
            {{ $t("orders_panel_download.btn_download") }}
          </BaseButton>
        </div>
        <BaseDivider color="v1-grey-4" class="mt-24 mb-24" />
        <div class="qrw-heading-xs">
          <span class="v1-grey-10-color bold"> Mobile App </span>
          <span class="v1-grey-6-color"> | </span>
          <span class="v1-grey-10-color">
            <BaseIcon icon="apple" size="sm2" />
            <BaseIcon icon="android" class="ml-8" size="sm2" />
          </span>
          <div class="panel-btns mt-16">
            <BaseButton
              size="md"
              class="mr-8"
              variant="secondary"
              icon="cards"
              @click="copyLink"
            >
              {{ $t("orders_panel_download.btn_copy") }}
            </BaseButton>
            <BaseButton size="md" class="mr-8" variant="secondary" icon="qr-scan">
              {{ $t("orders_panel_download.btn_qr") }}
            </BaseButton>
          </div>
        </div> -->
        <BaseDivider color="v1-grey-4" class="mt-24 mb-24" />
        <div class="qrw-heading-xs">
          <span class="v1-grey-10-color bold"> Telegram </span>
          <span class="v1-grey-7-color">
            | {{ $t("orders_panel_download.telegram_hint") }}
          </span>
        </div>
        <div class="panel-btns mt-16">
          <BaseButton
            size="md"
            class="mr-8"
            variant="secondary"
            @click="$router.push('/workers')"
          >
            {{ $t("orders_panel_download.btn_setup") }}
          </BaseButton>
        </div>
      </IQOS>
    </PageContainer>
  </div>
</template>

<style scoped>
.panel-btns {
  display: flex;
}

a {
  text-decoration: none;
}

</style>

<style>
.orders-panel-wrapper .dashboard-page-content {
  padding-bottom: 200px;
}
</style>

<script>
import ClipboardService from "@/services/clipboard";

export default {
  data() {
    return {
      show_queue_qrcode: false,
    };
  },
  methods: {
    copyLink() {
      ClipboardService.copyToClipboard(this.webQueueLink);

      this.$store.commit('ui/addToast', {
        variant: 'confirm',
        content: this.$t('notification_toast.confirm.copied')
      })
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    webQueueLink() {
      return `https://pos.qrwaiter.com.ua/login/${this.cafe.qId}`;
    },
  },
};
</script>
